"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 12.005,
  cy: 12.005,
  r: 8.3,
  fill: "var(--sds--ursa-icons--background-color, transparent)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "ursa-icon__75ecfe20a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.769 4.663a.7.7 0 0 1 .7.7V8.03a.7.7 0 0 1-.7.7H17.1a.7.7 0 1 1 0-1.4h1.968V5.363a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 12a9 9 0 0 1 16.905-4.304.7.7 0 0 1-1.23.67A7.6 7.6 0 1 0 19.6 12a.7.7 0 1 1 1.401 0 9 9 0 0 1-18 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 13.622a.7.7 0 0 1-.7-.7V8.957a.7.7 0 1 1 1.4 0v3.965a.7.7 0 0 1-.7.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.17 15.32a.83.83 0 1 1 1.66 0 .83.83 0 0 1-1.66 0"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.769 4.663a.7.7 0 0 1 .7.7V8.03a.7.7 0 0 1-.7.7H17.1a.7.7 0 1 1 0-1.4h1.968V5.363a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 12a9 9 0 0 1 16.905-4.304.7.7 0 0 1-1.23.67A7.6 7.6 0 1 0 19.6 12a.7.7 0 1 1 1.401 0 9 9 0 0 1-18 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 13.622a.7.7 0 0 1-.7-.7V8.957a.7.7 0 1 1 1.4 0v3.965a.7.7 0 0 1-.7.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.17 15.32a.83.83 0 1 1 1.66 0 .83.83 0 0 1-1.66 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.069 7.33v1.4a1.4 1.4 0 0 0 1.4-1.4zm.836.365 1.229-.67zm-.28.95.67 1.23zm-.95-.279-1.228.67zM11.3 12.922h1.4zm.7.7v1.4zm-.7-4.665H9.9zm1.4 0h-1.4zm0 3.965h1.4zm-1.53 2.398h-1.4zm.83-.83v1.4zm.83.83h-1.4zm-.83.83v1.4zm9.87-10.787a2.1 2.1 0 0 0-2.1-2.1v2.8a.7.7 0 0 1-.7-.7zm0 2.668V5.363h-2.8V8.03zm-2.1 2.1a2.1 2.1 0 0 0 2.1-2.1h-2.8a.7.7 0 0 1 .7-.7zm-2.668 0h2.668v-2.8H17.1zM15 8.03c0 1.16.94 2.1 2.1 2.1v-2.8a.7.7 0 0 1 .7.7zm2.1-2.1a2.1 2.1 0 0 0-2.1 2.1h2.8a.7.7 0 0 1-.7.7zm1.968 0H17.1v2.8h1.968zm-1.4-.568V7.33h2.8V5.363zm2.1-2.1a2.1 2.1 0 0 0-2.1 2.1h2.8a.7.7 0 0 1-.7.7zM12 1.6C6.256 1.6 1.6 6.257 1.6 12h2.8A7.6 7.6 0 0 1 12 4.4zm9.134 5.425A10.4 10.4 0 0 0 12 1.6v2.8a7.6 7.6 0 0 1 6.676 3.966zm-.838 2.85a2.1 2.1 0 0 0 .838-2.85l-2.458 1.341a.7.7 0 0 1 .279-.95zm-2.85-.838a2.1 2.1 0 0 0 2.85.837l-1.341-2.458a.7.7 0 0 1 .95.28zM12 5.8a6.2 6.2 0 0 1 5.447 3.237l2.458-1.342A9 9 0 0 0 12 3zM5.8 12A6.2 6.2 0 0 1 12 5.8V3a9 9 0 0 0-9 9zm6.2 6.2A6.2 6.2 0 0 1 5.8 12H3a9 9 0 0 0 9 9zm6.2-6.2a6.2 6.2 0 0 1-6.2 6.2V21a9 9 0 0 0 9-9zm2.1-2.1a2.1 2.1 0 0 0-2.1 2.1H21a.7.7 0 0 1-.7.7zm2.1 2.1a2.1 2.1 0 0 0-2.1-2.1v2.8a.7.7 0 0 1-.7-.7zM12 22.4c5.744 0 10.4-4.657 10.4-10.4h-2.8a7.6 7.6 0 0 1-7.6 7.6zM1.6 12c0 5.743 4.656 10.4 10.4 10.4v-2.8A7.6 7.6 0 0 1 4.4 12zm8.3.922c0 1.16.94 2.1 2.1 2.1v-2.8a.7.7 0 0 1 .7.7zm0-3.965v3.965h2.8V8.957zm2.1-2.1a2.1 2.1 0 0 0-2.1 2.1h2.8a.7.7 0 0 1-.7.7zm2.1 2.1a2.1 2.1 0 0 0-2.1-2.1v2.8a.7.7 0 0 1-.7-.7zm0 3.965V8.957h-2.8v3.965zm-2.1 2.1a2.1 2.1 0 0 0 2.1-2.1h-2.8a.7.7 0 0 1 .7-.7zm.57.298a.57.57 0 0 1-.57.57v-2.8a2.23 2.23 0 0 0-2.23 2.23zm-.57.57a.57.57 0 0 1-.57-.57h2.8A2.23 2.23 0 0 0 12 13.09zm-.57-.57a.57.57 0 0 1 .57-.57v2.8a2.23 2.23 0 0 0 2.23-2.23zm.57-.57a.57.57 0 0 1 .57.57h-2.8A2.23 2.23 0 0 0 12 17.55z",
  mask: "url(#ursa-icon__75ecfe20a)"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=SyncWarningIcon24.js.map